import { Video, FileText, ListChecks } from 'lucide-react';

export const LOOSE = '__loose__';
export const kind = (id) => String(id)[0];
export const raw = (id) => String(id).slice(2);

export const lessonType = (l) => l?.type || 'video';

export const TYPES = {
  video: { Icon: Video, ar: 'فيديو', en: 'Video', tile: 'bg-blue-50 text-blue-600' },
  text: { Icon: FileText, ar: 'درس مكتوب', en: 'Written lesson', tile: 'bg-blue-50 text-blue-600' },
  quiz: { Icon: ListChecks, ar: 'اختبار', en: 'Quiz', tile: 'bg-rose-50 text-rose-500' },
};

export const ytId = (url) => {
  const m = String(url || '').match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/))([\w-]{6,})/);
  return m ? m[1] : '';
};

export const buildItems = (sections, lessons) => {
  const known = new Set(sections.map(s => s.id));
  const m = { [LOOSE]: [] };
  sections.forEach(s => { m[s.id] = []; });
  [...lessons].sort((a, b) => (a.order || 0) - (b.order || 0))
    .forEach(l => m[known.has(l.section_id) ? l.section_id : LOOSE].push(l.id));
  return m;
};

export const lessonsCount = (lang, n) => (lang === 'ar' ? (n === 1 ? 'درس واحد' : n === 2 ? 'درسان' : `${n} ${n >= 3 && n <= 10 ? 'دروس' : n === 0 ? 'دروس' : 'درساً'}`) : `${n} lesson${n === 1 ? '' : 's'}`);
